import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Button from '@material-ui/core/Button';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import DoneIcon from '@material-ui/icons/Done';
import ErrorIcon from '@material-ui/icons/Error';
import DeleteIcon from '@material-ui/icons/Delete';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import _ from 'lodash';

import { showDialog, hideDialog, showError } from '../../redux/actions/dialogs';
import { formatLocation, filterTask, toJS } from '../../utils/helper';
import { saveTaskAssignmentsRoutine, fetchTasksRoutine, fetchEmployeesRoutine } from '../../redux/routines';
import icons from '../../utils/icons';

import AssignEmployeesToStagesDialog from '../Jobs/AssignEmployeesToStagesDialog';
import ReduxDialog from '../Common/ReduxDialog';

import styles from './styles';
import { ASSIGN_EMPLOYEES_TO_STAGES_DIALOG, ASSIGN_RESOURCES_TO_TASKS_DIALOG } from '../../redux/constants/dialogs';

const emptyExtractor = (task) => '';
const originExtractor = (task) => task.origin ? `${task.origin.building || ''}, ${task.origin.space || ''}` : '';
const destinationExtractor = (task) => task.destination ? `${task.destination.building || ''}, ${task.destination.space || ''}` : '';

class AssignResourcesToTasksDialog extends Component {
  state = {
    selectedRows: [],
    query: [{
      where: emptyExtractor,
      condition: '',
      substring: '',
    }],
  };

  componentWillMount() {
    this.props.fetchEmployees();
    this.props.fetchTasks(this.props.job.id);
  }

  // componentWillReceiveProps(nextProps) {
  //   console.log('nextProps.job', nextProps.job);
  //   if (nextProps.job && nextProps.job.id) {
  //     nextProps.fetchTasks(nextProps.job.id);
  //   }
  // }

  handleUpdateInput = (searchText, a, b, c) => {
    this.setState({
      searchText,
    });
  };

  handleSelectEmployee = (employee) => {
    this.setState({
      employee,
    });
  };

  handleSelectRole = (role) => {
    this.setState({
      role,
    });
  };

  handleWhereChange = (value, index) => {
    const temp = this.state.query;
    temp[index].where = value;
    this.setState({ query: temp });
  };

  handleConditionChange = (value, index) => {
    const temp = this.state.query;
    temp[index].condition = value;
    this.setState({ query: temp });
  };

  handleChange = (event, value, index) => {
    const temp = this.state.query;
    temp[index].substring = value.trim();
    this.setState({ query: temp });
  };

  handleSave = () => {
    this.props.saveTaskAssignments(this.props.tasks.filter((task) => task.changed));
    this.props.hideDialog(ASSIGN_RESOURCES_TO_TASKS_DIALOG);
  };

  handleRemoveAssignment = (task) => {
    console.log('handleRemoveAssignment', task);
  };

  addFilter() {
    const temp = this.state.query;
    temp.push({
      where: emptyExtractor,
      condition: 'Contains',
      substring: '',
    });
    this.setState({
      query: temp,
    });
  }

  handleRemoveFilter(index) {
    const temp = this.state.query;
    temp.splice(index, 1);
    this.setState({ query: temp });
  }

  handleAssignEmployeesToStages() {
    const { job } = this.props;
    if (this.state.selectedRows.length < 1) {
      return this.props.showError('Validation Errors', 'Please select the tasks you want to assign employees to');
    }

    // this.props.selectTasksSuccess(this.state.selectedRows);
    const tasks = this.props.tasks.filter((task, idx) => this.state.selectedRows.indexOf(idx) >= 0);
    this.props.showDialog(ASSIGN_EMPLOYEES_TO_STAGES_DIALOG, {
      stages: job.profile.stages,
      tasks,
    });
    return null;
  }

  handleTaskSelection = (evt) => {
    let selectedRows = [];
    switch (evt) {
      case 'all':
        selectedRows = _.range(0, this.state.limit);
        break;
      case 'none':
        selectedRows = [];
        break;
      default:
        selectedRows = evt;
        break;
    }

    this.setState({
      selectedRows,
    });

    // switch (selectedRows) {
    //   case 'all':
    //     selectedRows = _.range(0, this.props.tasks.length);
    //     break;
    //   case 'none':
    //     selectedRows = [];
    //     break;
    //   default:
    //     break;
    // }

    // let tasks = selectedRows;
    // if (selectedRows === 'all') {
    //   tasks = _.range(0, this.props.tasks.length);
    //   console.log('tasks', tasks.length, this.props.tasks.length);
    // } else if (selectedRows === 'none') {
    //   tasks = [];
    // }

    // this.setState({ selectedRows });
  };

  renderNoData() {
    return (<TableRow>
      <TableCell colSpan={3} style={styles.noDataRow}>
        <PersonAddIcon style={styles.noData}/>
        <div>No tasks...</div>
      </TableCell>
    </TableRow>);
  }

  renderStageStatus = (task, stage, index) => {
    let icon;
    if (task.stages && task.stages[stage.id] && task.stages[stage.id].assignedTo) {
      icon = (<DoneIcon style={styles.stage} color="green"/>);
    } else {
      icon = (<ErrorIcon style={styles.stage} color="lightgrey"/>);
    }

    return (<TableCell key={index} style={styles.stageCol}>{icon}</TableCell>);
  };

  renderTask(task, i) {
    return (<TableRow
      key={task.id} className="table-row" selected={this.state.selectedRows.indexOf(i) >= 0}
    >
      <TableCell
        headers="origin"
        className="td"
      >{formatLocation(task.origin)}</TableCell>
      <TableCell
        headers="destination"
        className="td"
      >{formatLocation(task.destination)}</TableCell>
      {this.props.job.profile.stages.map((stage, index) => this.renderStageStatus(task, stage, index))}
    </TableRow>);
  }

  renderTasks() {
    // console.log(this.props.tasks);
    const tasks = (this.props.tasks || []).filter((task) => filterTask(task, this.state.query));
    const { job } = this.props;

    return (<div style={styles.resources}>
      <div>
        <Table
          selectable
          multiSelectable
          className="table"
          onRowSelection={this.handleTaskSelection}
        >
          <TableHead displaySelectAll adjustForCheckbox className="table-header">
            <TableRow>
              <TableCell>Origin</TableCell>
              <TableCell>Destination</TableCell>

              {job.profile && job.profile.stages ? job.profile.stages.map((stage) => <TableCell
                key={stage.id}
                style={styles.stageCol}
              ><img src={icons[stage.icon]} style={styles.stageIcon} alt={stage.name}/></TableCell>) : null}
            </TableRow>
          </TableHead>
          <TableBody displayRowCheckbox>
            {tasks.length > 0 ? tasks.map((task, i) => this.renderTask(task, i)) : this.renderNoData()}
          </TableBody>
        </Table>
      </div>
    </div>);
  }

  renderFilter(queryInstance, index) {
    return (<div key={index} style={styles.filterRow}>
      {index === 0 ? <h3 style={styles.header}> Where </h3> : null}
      <Select
        hintText="Name"
        value={queryInstance.where}
        onChange={(event, fakeIndex, value) => this.handleWhereChange(value, index)}
        autoWidth
      >
        {/* <MenuItem*/}
        {/* value="job Date" primaryText="Job Date"*/}
        {/* />*/}
        <MenuItem value={originExtractor}>Origin</MenuItem>
        <MenuItem value={destinationExtractor}>Destination</MenuItem>
        {/* <MenuItem value="stages unassigned" primaryText="Stages Unassigned"/>*/}
      </Select>

      <Select
        hintText="condition"
        value={queryInstance.condition}
        onChange={(event, fakeIndex, value) => this.handleConditionChange(value, index)}
        autoWidth
      >
        <MenuItem value="Contains">contains</MenuItem>
        <MenuItem value="Does not contain">does not contain</MenuItem>
        <MenuItem value="Is">is</MenuItem>
        <MenuItem value="Is not">is not</MenuItem>
        <MenuItem value="Is empty">is empty</MenuItem>
        <MenuItem value="Is not empty">is not empty</MenuItem>
      </Select>
      <TextField
        name={index.toString()}
        hintText="Value"
        value={queryInstance.substring}
        onChange={(event, value) => (this.handleChange(event, value, index))}
      />
      <Button
        onClick={() => this.handleRemoveFilter(index)}
        style={styles.icon}
      >
        <DeleteIcon/>
      </Button>
    </div>);
  }

  render() {
    if (!this.props.job || !this.props.job.id) {
      return null;
    }

    const actions = [
      <Button
        key="cancel"
        variant="text"
        color="primary"
        onClick={() => this.props.hideDialog(ASSIGN_RESOURCES_TO_TASKS_DIALOG)}
      >Cancel</Button>,
      <Button
        key="save"
        variant="text"
        color="primary"
        autoFocus
        onClick={() => this.handleSave()}
      >Save</Button>,
    ];
    return (
      <ReduxDialog
        name={ASSIGN_RESOURCES_TO_TASKS_DIALOG}
        title="Assign Resources To Tasks"
        actions={actions}
        modal={false}
        autoScrollBodyContent
        bodyStyle={styles.body}
      >
        <div>{this.state.query.map((rule, idx) => this.renderFilter(rule, idx))}</div>
        <div style={styles.clear}>

          <Button
            variant="text"
            style={styles.flatBtn}
            onClick={() => this.addFilter()}
            icon={<i style={styles.font} className="material-icons">add</i>}
          >Add filter</Button>
        </div>
        <br/>
        <Button
          variant="text"
          labelPosition="before"
          color="primary"
          style={styles.selectedCount}
          onClick={() => this.handleAssignEmployeesToStages()}
          icon={<PersonAddIcon
            style={styles.stage}
          />}>
          {`ASSIGN (${this.state.selectedRows.length > 0 ? this.state.selectedRows.length + ' ' : ''}${this.state.selectedRows.length > 1 ? 'TASKS' : 'TASK'})`}
        </Button>

        {this.renderTasks()}
        <AssignEmployeesToStagesDialog/>
      </ReduxDialog>
    );
  }
}

// const form = reduxForm({
//   form: 'AssignResourcesToTasks',  // a unique identifier for this form
//   initialValues: {},
// })(AssignResourcesToTasks);

function mapStateToProps(state) {
  return {
    job: toJS(state.getIn(['jobs', 'job'])),
    employees: toJS(state.getIn(['employees', 'employees', 'data'])),
    tasks: toJS(state.getIn(['tasks', 'tasks', 'data']).toJS()),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchEmployees: fetchEmployeesRoutine.trigger,
    fetchTasks: (jobId) => fetchTasksRoutine.trigger({ jobId }),
    showDialog,
    hideDialog,
    showError,
    saveTaskAssignments: (tasks) => saveTaskAssignmentsRoutine.trigger(tasks),
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AssignResourcesToTasksDialog);



// WEBPACK FOOTER //
// ./src/components/AssignResourcesToTasksDialog/index.js